import { render, staticRenderFns } from "./ExitButton.vue?vue&type=template&id=5fc5012f"
import script from "./ExitButton.vue?vue&type=script&lang=js"
export * from "./ExitButton.vue?vue&type=script&lang=js"
import style0 from "./ExitButton.vue?vue&type=style&index=0&id=5fc5012f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports